import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const RELOAD_KEY = "statdoctor-chunk-reload";

const isStaleChunk = (error: unknown) => {
  const text = String((error as { message?: string })?.message || error || "");
  return /Loading chunk|Unexpected token|ChunkLoadError/i.test(text);
};

export function lazyWithChunkReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      if (isStaleChunk(error) && !sessionStorage.getItem(RELOAD_KEY)) {
        sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return new Promise(() => undefined);
      }
      throw error;
    }
  });
}
